import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FormatosServices from "./formatos.services";
import GestorDocumentalServices from '../../gestorDocumental/gestorDocumental.services';

export const getSancionesDocs = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_SANCIONES_DOCS,
      payload: true,
    });
    const resp = await FormatosServices.getSancionesDocs(filters);
    dispatch({
      type: actions.GET_SANCIONES_DOCS,
      payload: resp.data,
    });
    dispatch({
      type: actions.FAILD_SANCIONES_DOCS,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FAILD_SANCIONES_DOCS,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_SANCIONES_DOCS,
      payload: false,
    });
  }
}

export const getSancionesDoc = id => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_SANCIONES_DOC,
      payload: true,
    });
    const resp = await FormatosServices.getSancionesDoc(id);
    dispatch({
      type: actions.GET_SANCIONES_DOC,
      payload: resp.data,
    });
    dispatch({
      type: actions.FAILD_SANCIONES_DOC,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FAILD_SANCIONES_DOC,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_SANCIONES_DOC,
      payload: false,
    });
  }
}

export const saveSancionesDoc = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_SANCIONES_DOC,
      payload: true,
    });
    
    const {req, reqDoc} = data;
    const repGD = await GestorDocumentalServices.saveSancionesDocument(reqDoc);
    req.archivo = repGD.data.resultado.id;
    const resp = await FormatosServices.saveSancionesDoc(req);
    const { docs } = getState().sancionesDocs;
    dispatch({
      type: actions.GET_SANCIONES_DOCS,
      payload: {
        count: docs.count + 1,
        data: [...docs.data, resp.data]
      },
    });
    dispatch({
      type: actions.FORM_SANCIONES_DOC_FAILD,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
    setShowModal(false);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            message = ex.response.data.resultado[0].response;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_SANCIONES_DOC_FAILD,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADER_SANCIONES_DOC,
      payload: false,
    });
  }
}

export const editSancionesDoc = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_SANCIONES_DOC,
      payload: true,
    });
    const {req, reqDoc} = data;
    if (reqDoc){
      await GestorDocumentalServices.editSancionesDocument(reqDoc.id, reqDoc);
    }
    const resp = await FormatosServices.editSancionesDoc(id, req);
    const { docs } = getState().sancionesDocs;
    let _docsData = docs.data.slice();
    _docsData[index] = resp.data;
    dispatch({
      type: actions.GET_SANCIONES_DOCS,
      payload: {
        count: docs.count,
        data: _docsData
      },
    });
    dispatch({
      type: actions.FORM_SANCIONES_DOC_FAILD,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
    setShowModal(false);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_SANCIONES_DOC_FAILD,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADER_SANCIONES_DOC,
      payload: false,
    });
  }
}

export const deleteSancionesDoc = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_SANCIONES_DOCS,
      payload: true,
    });
    await FormatosServices.deleteSancionesDoc(id);
    const { docs } = getState().sancionesDocs;
    let _docsData = docs.data.slice();
    _docsData.splice(index, 1);
    dispatch({
      type: actions.GET_SANCIONES_DOCS,
      payload: {
        data: _docsData,
        count: docs.count - 1
      }
    });
    dispatch({
      type: actions.FAILD_SANCIONES_DOCS,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FAILD_SANCIONES_DOCS,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_SANCIONES_DOCS,
      payload: false,
    });
  }
}